/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
import { colors } from "../../theme";

const Label = ({ children, ...props }) => (
    <label
        {...props}
        css={css`
            color: ${colors.neutral7};
            line-height: 1.25;
            font-size: 16px;
            height: 19px;
            margin-bottom: 5px;
        `}
    >
        {children}
    </label>
);

export default Label;
